import type { ReactNode } from "react";

interface AuthFormCardProps {
  readonly title: string;
  readonly subtitle?: string;
  /** Optional content rendered between subtitle and form (e.g., role badge) */
  readonly headerExtra?: ReactNode;
  /** Use wider card (max-w-lg) for forms with more fields like sign-up */
  readonly wide?: boolean;
  readonly children: ReactNode;
}

/**
 * Shared card wrapper for all auth forms.
 * Provides consistent styling: white card with shadow, centered heading, and form slot.
 */
export function AuthFormCard({
  title,
  subtitle,
  headerExtra,
  wide = false,
  children,
}: AuthFormCardProps) {
  return (
    <div
      className={`auth-form w-full ${wide ? "max-w-lg" : "max-w-sm"} mx-auto`}
    >
      <div className="mb-7">
        <h1 className="text-2xl font-semibold text-text-primary tracking-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-2 text-sm text-text-tertiary">{subtitle}</p>
        )}
        {headerExtra}
      </div>
      {children}
    </div>
  );
}
